export default __webpack_public_path__ + "e1071f00fce0f16c83b5be29061376ba.png";